import { FilterKey } from '@studyportals/search-filters';
import { FilterSelectionState } from '@/filters/selection/FilterSelectionState';
import { Degree } from '@/models/Degree';
import { ISeoMetaDataInfo } from '../ISeoMetaDataInfo';
import { SeoMetaDataHandlerDefaultSort } from '../SeoMetaDataHandlerDefaultSort';

export default class Country extends SeoMetaDataHandlerDefaultSort {
	protected async canHandleWithDefaultSorting(filterSelectionState: FilterSelectionState): Promise<boolean> {
		return await this.singleSelectionFor(FilterKey.COUNTRY, filterSelectionState)
			&& await this.selectionOnlyFor([FilterKey.COUNTRY], filterSelectionState);
	}
	
	protected async selfHandle(degree: Degree, filterSelectionState: FilterSelectionState): Promise<ISeoMetaDataInfo> {
		const portalName = degree.toPortalName();

		const country = this.getFilterOptionNameBy(FilterKey.COUNTRY, filterSelectionState);

		const seoInfo = {
			title: `Complete list of universities in ${country} | ${portalName}`,

			description:
				`Looking for universities in ${country}? ` +
				`Browse our comprehensive list to explore and ` +
				`narrow down your choice by attendance and more.`,
		};

		return Promise.resolve(seoInfo);
	}
}
